import React from 'react';
export const ThemeContext = React.createContext(
   {
      darkMode: localStorage.getItem('SB_THEME') === 'true' || (!localStorage.getItem('SB_THEME') && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches),
      toggleTheme: () => { }
   }
);
